import { Box, Checkbox, FormControl, FormHelperText, Link, Typography } from "@mui/material"
import { useFormikContext } from "formik"
import type { ChangeEvent } from "react"
import { tss } from "tss-react/mui"

import { LocalizedStrict } from "../../../../../../modules/localization/components/AppLocalized"

import type { CheckoutFormValues } from "./takeawayCheckoutLib"

const useStyles = tss.create(() => ({
    root: {
        "& .MuiFormHelperText-root": {
            marginLeft: 0,
        },
    },
    row: {
        marginLeft: "-11px",
        display: "flex",
        alignItems: "center",
    },
}))

type TakeawayCheckoutTermsSectionProps = Readonly<{
    salesConditionsUrl: string
}>

export function TakeawayCheckoutTermsSection({ salesConditionsUrl }: TakeawayCheckoutTermsSectionProps) {
    const { classes } = useStyles()
    const { values, errors, touched, submitCount, handleChange, setFieldTouched } =
        useFormikContext<CheckoutFormValues>()

    const hasError = (touched.termsAccepted || submitCount > 0) && Boolean(errors.termsAccepted)

    // Functionality to appear an error message only after the user unchecks the box, so we mark the field
    // as touched at that moment instead of on blur.
    function handleTermsChange(e: ChangeEvent<HTMLInputElement>) {
        handleChange(e)
        if (!e.target.checked) setFieldTouched("termsAccepted", true, false)
    }

    return (
        <div className={classes.root}>
            <FormControl error={hasError}>
                <Box className={classes.row}>
                    <Checkbox name="termsAccepted" checked={values.termsAccepted} onChange={handleTermsChange} />
                    <LocalizedStrict
                        id="takeaway-checkout-terms-accepted-label"
                        elems={{
                            conditionsLink: (
                                <Link
                                    href={salesConditionsUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    variant="inherit"
                                />
                            ),
                        }}
                    >
                        <Typography variant="body1">
                            I accept the{" "}
                            <Link href={salesConditionsUrl} target="_blank" rel="noopener noreferrer" variant="inherit">
                                terms and conditions
                            </Link>
                        </Typography>
                    </LocalizedStrict>
                </Box>
                {hasError && <FormHelperText>{errors.termsAccepted}</FormHelperText>}
            </FormControl>
        </div>
    )
}
